import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    iframe: {
      position: 'absolute',
      top: 0,
      left: 0,
      display: 'block',
      width: '100%',
      height: '100%',
    },
  }),
  { name: 'youtube-embed-video' },
);

export default useStyles;
